import React, { ReactNode } from 'react';
import './SpotForm.scss';

/**
 * Wrapper for the other form components. Attempts to be spot compliant. Isn't actually a HTML form to allow greater
 * flexibility in what happens when you click buttons or try to submit.
 */
export default function SpotForm(props: { children?: ReactNode }): React.JSX.Element {
    return (
        <div className={'custom-form'}>
            <div className="spot-form">{props.children}</div>
        </div>
    );
}
